<div theme [class]="DXCToasterCssClass">
    <dxc-alert
      margin="medium"
      [type]="DXCToasterType"
      [inlineText]="DXCToasterInlineText"
      [mode]="DXCToasterMode"
    ></dxc-alert>
</div>

